var map = {
	"./AI.png": "c4e84",
	"./FMlogo.png": "6cd1",
	"./activity.png": "2892",
	"./arrowTop.png": "85d4",
	"./arrowUp.png": "ad96",
	"./back.png": "1faf",
	"./backti.png": "2fa6",
	"./carCard.png": "4d6f",
	"./chat.png": "84f6",
	"./clock.png": "25a3",
	"./close.png": "04b3",
	"./closeTip.png": "0fd6",
	"./closeWhite.png": "ca2c1",
	"./coverBg.png": "c9c3",
	"./defaultNew.png": "453d",
	"./empty.png": "b45c",
	"./goDown.png": "70ca",
	"./goUp.png": "e026",
	"./goodComment.png": "06c1",
	"./hongbao/0.png": "39c8",
	"./hongbao/1.png": "ca5f",
	"./hongbao/10.png": "fbd8",
	"./hongbao/11.png": "b906",
	"./hongbao/12.png": "5786",
	"./hongbao/13.png": "7ae6",
	"./hongbao/14.png": "3a76",
	"./hongbao/15.png": "82d6",
	"./hongbao/16.png": "0fbe",
	"./hongbao/17.png": "a962",
	"./hongbao/18.png": "36a0",
	"./hongbao/19.png": "9b47",
	"./hongbao/2.png": "56ce",
	"./hongbao/20.png": "ffcb",
	"./hongbao/21.png": "dc97",
	"./hongbao/22.png": "3d18",
	"./hongbao/23.png": "ad6a",
	"./hongbao/24.png": "d7be",
	"./hongbao/25.png": "9ff2",
	"./hongbao/26.png": "4814",
	"./hongbao/27.png": "90e7",
	"./hongbao/28.png": "ef37",
	"./hongbao/29.png": "6b1b",
	"./hongbao/3.png": "6470",
	"./hongbao/30.png": "4d12",
	"./hongbao/31.png": "836d",
	"./hongbao/32.png": "53ef",
	"./hongbao/33.png": "569c",
	"./hongbao/34.png": "c2ec",
	"./hongbao/35.png": "76b3",
	"./hongbao/36.png": "7441",
	"./hongbao/37.png": "9313",
	"./hongbao/38.png": "3c7d",
	"./hongbao/39.png": "1ef4",
	"./hongbao/4.png": "3ca8",
	"./hongbao/40.png": "a371",
	"./hongbao/41.png": "e0e1",
	"./hongbao/42.png": "107a",
	"./hongbao/43.png": "af1a",
	"./hongbao/44.png": "1de3",
	"./hongbao/45.png": "3941",
	"./hongbao/46.png": "0359",
	"./hongbao/47.png": "6e9e",
	"./hongbao/48.png": "4bca",
	"./hongbao/49.png": "f9a9",
	"./hongbao/5.png": "6ea2",
	"./hongbao/50.png": "9fa6",
	"./hongbao/51.png": "6ba1",
	"./hongbao/52.png": "3677",
	"./hongbao/53.png": "0486",
	"./hongbao/54.png": "6816",
	"./hongbao/6.png": "0682",
	"./hongbao/7.png": "970d",
	"./hongbao/8.png": "14d4",
	"./hongbao/9.png": "a200",
	"./hot.png": "60b1",
	"./introduce.png": "e7b3",
	"./lastAudio.png": "4d9c",
	"./leftStr.png": "e561",
	"./like.png": "ef74",
	"./newsImg.png": "20e7",
	"./nextAudio.png": "4f27",
	"./openTime.png": "e251",
	"./pauseAudio.png": "e6f4",
	"./phone.png": "9347",
	"./play.png": "d99c",
	"./playAudio.png": "d9c7",
	"./position.png": "b9f8",
	"./recom.png": "bad0",
	"./reload.png": "7b3d",
	"./rightStr.png": "b737",
	"./robot/aavatar.png": "bfb0",
	"./robot/chatbg.png": "d452",
	"./robot/children.png": "1a6f",
	"./robot/cover.png": "f2da",
	"./robot/qavatar.png": "9407",
	"./send.png": "fbe7",
	"./star.png": "ba5a",
	"./starci.png": "7172",
	"./stockTitle.png": "8ad0",
	"./stop.png": "bf2e",
	"./time.png": "e1fe",
	"./tiny.png": "d006",
	"./tinyic.png": "e6bc",
	"./toastImgMask.png": "2350",
	"./traffic.png": "9d46",
	"./voiceBtn.png": "fecb",
	"./voiceClose.png": "905f",
	"./voiceDel.png": "fc0f",
	"./voiceOpen.png": "c2af",
	"./wordBtn.png": "fb74",
	"./xiaofeng.png": "7498"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";